import { render, staticRenderFns } from "./BubbleTextMenu.vue?vue&type=template&id=a565d4d8"
import script from "./BubbleTextMenu.vue?vue&type=script&lang=js"
export * from "./BubbleTextMenu.vue?vue&type=script&lang=js"
import style0 from "./BubbleTextMenu.vue?vue&type=style&index=0&id=a565d4d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports